import useSmsCreditAccess from "@/modules/smsCredit/useSmsCreditAccess";
import { Navigate } from "react-router-dom";
import { Button, Group } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import useIsSmall from "@/hooks/useIsSmall";
import SmsCredit from "@/modules/smsCredit";
import { Container, Stack, Text, Title } from "@mantine/core";
export default function SmsCreditPage() {
  const isSmall = useIsSmall();
  const { allowed, isLoading } = useSmsCreditAccess();
  if (isLoading) return null;
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return <Container size="sm" py="xl" w="100%" dir="rtl"><Stack gap="xs">{isSmall && <Group><Button component={Link} to="/dashboard" variant="subtle" color="gray" leftSection={<IconArrowRight size={18} />}>بازگشت به داشبورد</Button></Group>}<Title order={2}>شارژ پیامکی</Title><Text c="dimmed">مانده شارژ پیامکی را ببینید و اعتبار ارسال پیامک را افزایش دهید.</Text><SmsCredit /></Stack></Container>;
}
